define('directives/common/verify-code/verify-email-code.directive',['app', 'mainCons'], function (app, mainCons) {
    app.directive('verifyEmailCode', ['$q', '$timeout','$filter', 'OpenUp', 'OpenOther', function ($q, $timeout,$filter, OpenUp, OpenOther) {
        var timeout;
        return {
            restrict: 'E',
            scope: {
                verEmail: "=",
                verCode: "=",
                verDirty:"=",
                verSuccess:"=",
                resetVer:"="
            },
            replace: true,
            require: "?ngModel",
            templateUrl: '../refactor/directives/common/verify-code/verify-email-code.template.html',
            link: function ($scope, element, attrs, ngModelCtrl) {
                var timer;
                $scope.isCountSecond = false;
                $scope.isVerCodeBtn = true;
                var repeatCount = 0;
                // 短信验证码有效时间
                $scope.timeoutCount = angular.copy(systemParaConf.user.phoneCodeTimeout);

                $scope.verEmail = $scope.verEmail;
                $scope.verType = 2;

                $scope.$watch('verEmail', function () {
                        reset();
                });
                $scope.$watch('resetVer', function () {
                    reset();
                    $scope.resetVer = false;
                });

                function reset() {
                    $scope.verCode = "";
                    $scope.isCountSecond = false;
                    $scope.isVerCodeBtn = true;
                    $scope.verSuccess = false;
                    $scope.verFailed = false;
                    $scope.isVerDisabled =false;
                    repeatCount = 0;
                }


                $scope.$watch('verDirty', function () {
                    if($scope.verDirty){
                        $scope.verifyForm.verifyEmailCode.$setDirty();
                    }
                });

                $scope.$watch('verCode', function (newValue, oldValue) {
                    $scope.verSuccess = false;
                    $scope.verFailed = false;
                    $scope.verFailedOfError = false;
                    $scope.verFailedOfTimes = false;
                    $scope.isVerDisabled =false;
                    if (!newValue && !oldValue) {
                        return;
                    }
                    if (newValue && $scope.verifyForm.$valid && newValue.length == 6) {
                        OpenOther.verifyEmailAuthCode({
                            req: {
                                email: $scope.verEmail,
                                authCode:newValue,
                                authCodeVerifyType: 0
                            }
                        },true).then(function (res) {
                            if (res && res.userID) {
                                var timerTemp = $timeout(function() {
                                    $timeout.cancel(timerTemp);
                                    $scope.verCode = "";
                                    $scope.isCountSecond = false;
                                    $scope.isVerCodeBtn = true;
                                    $scope.verSuccess = false;
                                    $scope.verFailed = false;
                                    $scope.isVerDisabled =false;
                                }, 300000);
                                $scope.verSuccess = true;
                                $scope.isVerDisabled =true;
                            }
                            else if (res &&(res.NSP_STATUS =='90320004' || res.NSP_STATUS =='90320005')) {
                                $scope.verSuccess = false;
                                $scope.verFailed = true;
                                $scope.verFailedOfTimes = true;
                            } else {
                                $scope.verSuccess = false;
                                $scope.verFailed = true;
                                $scope.verFailedOfError = true;
                            }
                        }).catch(function (res) {
                            if (res &&(res.NSP_STATUS =='90320004' || res.NSP_STATUS =='90320005')) {
                                $scope.verFailedOfTimes = true;
                            } else {
                                $scope.verFailedOfError = true;
                            }
                            $scope.verSuccess = false;
                            $scope.verFailed = true;
                        });
                    }
                });

                $scope.getVerCode = function () {
                    var defer = $q.defer();
                    getEmailVerCode($scope.verEmail).then(function (data) {
                        if (data.userID) {
                            $scope.timeoutCount = systemParaConf.user.phoneCodeTimeout;
                            // 改变样式为倒计时
                            $scope.isCountSecond = true;
                            $scope.isVerCodeBtn = false;
                            // 计时开始
                            startEmailCodeTimer();
                            defer.resolve(data);
                        }else{
                            defer.resolve(data);
                        }
                    });
                    return defer.promise;
                };
                $scope.checkVerCode=function () {
                    if($scope.verCode && $scope.verCode.length !=0 && $scope.verCode.length<6 ){
                        $scope.verFailed = true;
                        $scope.verFailedOfError = true;
                    }
                };
                //获取验证码并设置倒计时
                function getEmailVerCode(email) {
                    var defer = $q.defer();
                    $timeout.cancel(timer);
                    OpenOther.sendEmailAuthCode({
                            req: {
                                email: email,
                                repeatCount:repeatCount
                            }
                        }).then(function (res) {
                        defer.resolve(res);
                    }).catch(function (res) {
                        defer.resolve(res);
                    });
                    return defer.promise;
                }

                // 计时器倒计时
                function startEmailCodeTimer() {
                    if ($scope.timeoutCount <= 0) {
                        $scope.isCountSecond = false;
                        $scope.isVerCodeBtn = true;
                        if(repeatCount <100){
                            repeatCount ++;
                        }else{
                            repeatCount =0;
                        }
                    }
                    else {
                        // 显示当前计时
                        $scope.timeoutCount--;
                        // 递归计时
                        timer = $timeout(startEmailCodeTimer, 1000);
                    }
                }
            }
        }
    }]);
});

